import { render, staticRenderFns } from "./salse_order_sucess.vue?vue&type=template&id=8fafe5d0&scoped=true&"
import script from "./salse_order_sucess.vue?vue&type=script&lang=js&"
export * from "./salse_order_sucess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fafe5d0",
  null
  
)

export default component.exports